import React from "react";
import { Dropdown } from "components/dropdown/Dropdown";
import { MultiDropdown } from "components/dropdown/MultiDropdown";
import { TriggerBase } from "../TriggerBase";
import { useDispatchedSurveyTrigger } from "./DispatchedSurveyTrigger.hooks";
import { DispatchedSurveyTriggerProps } from "./DispatchedSurveyTrigger.types";

const DispatchedSurveyTrigger: React.FC<DispatchedSurveyTriggerProps> = ({
  surveyTemplateOptions,
  projectOptions,
  triggerData,
  parsedData,
  setParsedData,
  referenceData,
  setReferenceData,
  showTriggerTypeSelector,
  setShowTriggerTypeSelector,
  workflowBuilderErrors,
}) => {
  const { handleChangeSurveyTemplate, handleChangeProject } = useDispatchedSurveyTrigger({
    parsedData,
    setParsedData,
    referenceData,
    setReferenceData,
  });

  return (
    <TriggerBase
      title="Dispatched survey"
      setShowTriggerTypeSelector={setShowTriggerTypeSelector}
      workflowBuilderErrors={workflowBuilderErrors}
    >
      <div className="Row">
        <div className="Label">Survey template</div>

        <Dropdown
          onChange={handleChangeSurveyTemplate}
          value={
            triggerData && triggerData.surveyTemplatesID
              ? (surveyTemplateOptions.find((o) => o.value === triggerData.surveyTemplatesID) ??
                null)
              : null
          }
          options={surveyTemplateOptions}
          placeholder="Please select"
          roundedRectangle
          portalMode={true}
          isClearable={true}
        />
      </div>

      <div className="Row">
        <div className="Label">Project type</div>

        <MultiDropdown
          customClassName="MultiDropdown"
          onChange={handleChangeProject}
          value={
            triggerData && triggerData.projectTypesIDs && Array.isArray(triggerData.projectTypesIDs)
              ? projectOptions.filter((o) => triggerData.projectTypesIDs.includes(o.value))
              : null
          }
          options={projectOptions}
          placeholder="Please select"
          isClearable={true}
          roundedRectangle
          portalMode={true}
        />
      </div>
    </TriggerBase>
  );
};

export default DispatchedSurveyTrigger;
